import { isPublicFolderComposeViewState } from './createPublicFolderComposeViewState';
import closeCompose from '../actions/closeCompose';
import trySaveMessage from '../actions/trySaveMessage';
import trySendMessage from '../actions/trySendMessage';
import ComposeViewState from '../store/schema/ComposeViewState';
import setSendDisabled from 'owa-mail-compose-store/lib/actions/setSendDisabled';

export default function handleOnSend(viewState: ComposeViewState) {
    if (isPublicFolderComposeViewState(viewState)) {
        trySaveMessage(viewState);
        closeCompose(viewState);
    } else {
        setSendDisabled(viewState, true);
        trySendMessage(viewState).catch(() => {
            // Re-enable the Send button when send fails, so user can try sending again
            // This includes the case where Send has been canceled by the user (i.e. undo send)
            setSendDisabled(viewState, false);
        });
    }
}
